export type GetOtherPlayerCapacityParams = {
  nodeRequirePlayerCounts: boolean | null | undefined;
  bookingType: string | null | undefined;
  isGolfCourse: boolean;
  nodeStandardCapacity: number | null | undefined;
  groupSize: number | null | undefined;
  playersLength: number;
  nodeUsedCapacity: number | null | undefined;
};

export function getOtherPlayerCapacity({
  nodeRequirePlayerCounts,
  isGolfCourse,
  bookingType,
  nodeStandardCapacity,
  groupSize,
  playersLength,
  nodeUsedCapacity,
}: GetOtherPlayerCapacityParams): number {
  if (bookingType === "LessonBooking") {
    return (groupSize || 1) - playersLength;
  }

  if (bookingType === "RequestBooking") {
    return (groupSize || 0) - playersLength;
  }
  if (!nodeRequirePlayerCounts) {
    return 0;
  }

  if (isGolfCourse) {
    const standardCapacity = nodeStandardCapacity ?? 0;
    const usedCapacity = nodeUsedCapacity ?? 0;
    return standardCapacity - usedCapacity - playersLength;
  }

  const effectiveGroupSize = groupSize || 1;
  return effectiveGroupSize - playersLength;
}
